module.exports = __webpack_public_path__ + "media/images/icon-product/book-1b8760c26b0309a43b518e17b85b102f.svg";